/* generated by Svelte v3.31.0 */
import { SvelteComponent, binding_callbacks, create_slot, detach, element, init, insert, listen, run_all, safe_not_equal, set_custom_element_data, transition_in, transition_out, update_slot } from "svelte/internal";
import { define } from "../lib";
import { VmDash, VmFile, VmVideo } from "@vime/core";
import { createEventDispatcher, onMount } from "svelte";
import { setProp } from "../lib";
function create_fragment(ctx) {
    let vm_dash;
    let vm_dash_src_value;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[26].default;
    const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[25], null);
    return {
        c() {
            vm_dash = element("vm-dash");
            if (default_slot)
                default_slot.c();
            set_custom_element_data(vm_dash, "class", /*className*/ ctx[0]);
            set_custom_element_data(vm_dash, "style", /*style*/ ctx[1]);
            if (vm_dash.src !== (vm_dash_src_value = /*src*/ ctx[2]))
                set_custom_element_data(vm_dash, "src", vm_dash_src_value);
            set_custom_element_data(vm_dash, "version", /*version*/ ctx[3]);
            set_custom_element_data(vm_dash, "lib-src", /*libSrc*/ ctx[4]);
            set_custom_element_data(vm_dash, "autoplay", /*autoplay*/ ctx[5]);
            set_custom_element_data(vm_dash, "cross-origin", /*crossOrigin*/ ctx[6]);
            set_custom_element_data(vm_dash, "preload", /*preload*/ ctx[7]);
            set_custom_element_data(vm_dash, "poster", /*poster*/ ctx[8]);
            set_custom_element_data(vm_dash, "controls-list", /*controlsList*/ ctx[9]);
            set_custom_element_data(vm_dash, "auto-pip", /*autoPiP*/ ctx[10]);
            set_custom_element_data(vm_dash, "disable-pip", /*disablePiP*/ ctx[11]);
            set_custom_element_data(vm_dash, "disable-remote-playback", /*disableRemotePlayback*/ ctx[12]);
            set_custom_element_data(vm_dash, "media-title", /*mediaTitle*/ ctx[13]);
            set_custom_element_data(vm_dash, "enable-text-tracks-by-default", /*enableTextTracksByDefault*/ ctx[14]);
            set_custom_element_data(vm_dash, "should-render-native-text-tracks", /*shouldRenderNativeTextTracks*/ ctx[15]);
            set_custom_element_data(vm_dash, "is-text-track-visible", /*isTextTrackVisible*/ ctx[16]);
            set_custom_element_data(vm_dash, "current-text-track", /*currentTextTrack*/ ctx[17]);
        },
        m(target, anchor) {
            insert(target, vm_dash, anchor);
            if (default_slot) {
                default_slot.m(vm_dash, null);
            }
            /*vm_dash_binding*/ ctx[27](vm_dash);
            current = true;
            if (!mounted) {
                dispose = [
                    listen(vm_dash, "vmLoadStart", /*onEvent*/ ctx[19]),
                    listen(vm_dash, "vmError", /*onEvent*/ ctx[19])
                ];
                mounted = true;
            }
        },
        p(ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && dirty & /*$$scope*/ 33554432) {
                    update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[25], dirty, null, null);
                }
            }
            if (!current || dirty & /*className*/ 1) {
                set_custom_element_data(vm_dash, "class", /*className*/ ctx[0]);
            }
            if (!current || dirty & /*style*/ 2) {
                set_custom_element_data(vm_dash, "style", /*style*/ ctx[1]);
            }
            if (!current || dirty & /*src*/ 4 && vm_dash.src !== (vm_dash_src_value = /*src*/ ctx[2])) {
                set_custom_element_data(vm_dash, "src", vm_dash_src_value);
            }
            if (!current || dirty & /*version*/ 8) {
                set_custom_element_data(vm_dash, "version", /*version*/ ctx[3]);
            }
            if (!current || dirty & /*libSrc*/ 16) {
                set_custom_element_data(vm_dash, "lib-src", /*libSrc*/ ctx[4]);
            }
            if (!current || dirty & /*autoplay*/ 32) {
                set_custom_element_data(vm_dash, "autoplay", /*autoplay*/ ctx[5]);
            }
            if (!current || dirty & /*crossOrigin*/ 64) {
                set_custom_element_data(vm_dash, "cross-origin", /*crossOrigin*/ ctx[6]);
            }
            if (!current || dirty & /*preload*/ 128) {
                set_custom_element_data(vm_dash, "preload", /*preload*/ ctx[7]);
            }
            if (!current || dirty & /*poster*/ 256) {
                set_custom_element_data(vm_dash, "poster", /*poster*/ ctx[8]);
            }
            if (!current || dirty & /*controlsList*/ 512) {
                set_custom_element_data(vm_dash, "controls-list", /*controlsList*/ ctx[9]);
            }
            if (!current || dirty & /*autoPiP*/ 1024) {
                set_custom_element_data(vm_dash, "auto-pip", /*autoPiP*/ ctx[10]);
            }
            if (!current || dirty & /*disablePiP*/ 2048) {
                set_custom_element_data(vm_dash, "disable-pip", /*disablePiP*/ ctx[11]);
            }
            if (!current || dirty & /*disableRemotePlayback*/ 4096) {
                set_custom_element_data(vm_dash, "disable-remote-playback", /*disableRemotePlayback*/ ctx[12]);
            }
            if (!current || dirty & /*mediaTitle*/ 8192) {
                set_custom_element_data(vm_dash, "media-title", /*mediaTitle*/ ctx[13]);
            }
            if (!current || dirty & /*enableTextTracksByDefault*/ 16384) {
                set_custom_element_data(vm_dash, "enable-text-tracks-by-default", /*enableTextTracksByDefault*/ ctx[14]);
            }
            if (!current || dirty & /*shouldRenderNativeTextTracks*/ 32768) {
                set_custom_element_data(vm_dash, "should-render-native-text-tracks", /*shouldRenderNativeTextTracks*/ ctx[15]);
            }
            if (!current || dirty & /*isTextTrackVisible*/ 65536) {
                set_custom_element_data(vm_dash, "is-text-track-visible", /*isTextTrackVisible*/ ctx[16]);
            }
            if (!current || dirty & /*currentTextTrack*/ 131072) {
                set_custom_element_data(vm_dash, "current-text-track", /*currentTextTrack*/ ctx[17]);
            }
        },
        i(local) {
            if (current)
                return;
            transition_in(default_slot, local);
            current = true;
        },
        o(local) {
            transition_out(default_slot, local);
            current = false;
        },
        d(detaching) {
            if (detaching)
                detach(vm_dash);
            if (default_slot)
                default_slot.d(detaching);
            /*vm_dash_binding*/ ctx[27](null);
            mounted = false;
            run_all(dispose);
        }
    };
}
define("vm-dash", VmDash);
define("vm-file", VmFile);
define("vm-video", VmVideo);
function instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope } = $$props;
    let __ref;
    let __mounted = false;
    const dispatch = createEventDispatcher();
    let { class: className } = $$props;
    let { style } = $$props;
    let { src } = $$props;
    let { version = "latest" } = $$props;
    let { libSrc = undefined } = $$props;
    let { config = {} } = $$props;
    let { autoplay = false } = $$props;
    let { crossOrigin = undefined } = $$props;
    let { preload = "metadata" } = $$props;
    let { poster = undefined } = $$props;
    let { controlsList = undefined } = $$props;
    let { autoPiP = undefined } = $$props;
    let { disablePiP = undefined } = $$props;
    let { disableRemotePlayback = undefined } = $$props;
    let { mediaTitle = undefined } = $$props;
    let { enableTextTracksByDefault = true } = $$props;
    let { shouldRenderNativeTextTracks = true } = $$props;
    let { isTextTrackVisible = true } = $$props;
    let { currentTextTrack = -1 } = $$props;
    const getAdapter = (...args) => __ref.getAdapter(...args);
    const ref = () => __ref;
    const getWebComponent = () => __ref;
    onMount(() => {
        $$invalidate(24, __mounted = true);
    });
    const onEvent = e => {
        e.stopPropagation();
        dispatch(e.type, e.detail);
    };
    function vm_dash_binding($$value) {
        binding_callbacks[$$value ? "unshift" : "push"](() => {
            __ref = $$value;
            $$invalidate(18, __ref);
        });
    }
    $$self.$$set = $$props => {
        if ("class" in $$props)
            $$invalidate(0, className = $$props.class);
        if ("style" in $$props)
            $$invalidate(1, style = $$props.style);
        if ("src" in $$props)
            $$invalidate(2, src = $$props.src);
        if ("version" in $$props)
            $$invalidate(3, version = $$props.version);
        if ("libSrc" in $$props)
            $$invalidate(4, libSrc = $$props.libSrc);
        if ("config" in $$props)
            $$invalidate(20, config = $$props.config);
        if ("autoplay" in $$props)
            $$invalidate(5, autoplay = $$props.autoplay);
        if ("crossOrigin" in $$props)
            $$invalidate(6, crossOrigin = $$props.crossOrigin);
        if ("preload" in $$props)
            $$invalidate(7, preload = $$props.preload);
        if ("poster" in $$props)
            $$invalidate(8, poster = $$props.poster);
        if ("controlsList" in $$props)
            $$invalidate(9, controlsList = $$props.controlsList);
        if ("autoPiP" in $$props)
            $$invalidate(10, autoPiP = $$props.autoPiP);
        if ("disablePiP" in $$props)
            $$invalidate(11, disablePiP = $$props.disablePiP);
        if ("disableRemotePlayback" in $$props)
            $$invalidate(12, disableRemotePlayback = $$props.disableRemotePlayback);
        if ("mediaTitle" in $$props)
            $$invalidate(13, mediaTitle = $$props.mediaTitle);
        if ("enableTextTracksByDefault" in $$props)
            $$invalidate(14, enableTextTracksByDefault = $$props.enableTextTracksByDefault);
        if ("shouldRenderNativeTextTracks" in $$props)
            $$invalidate(15, shouldRenderNativeTextTracks = $$props.shouldRenderNativeTextTracks);
        if ("isTextTrackVisible" in $$props)
            $$invalidate(16, isTextTrackVisible = $$props.isTextTrackVisible);
        if ("currentTextTrack" in $$props)
            $$invalidate(17, currentTextTrack = $$props.currentTextTrack);
        if ("$$scope" in $$props)
            $$invalidate(25, $$scope = $$props.$$scope);
    };
    $$self.$$.update = () => {
        if ($$self.$$.dirty & /*__mounted, __ref, config*/ 18087936) {
            $: if (__mounted)
                setProp(__ref, "config", config);
        }
    };
    return [
        className,
        style,
        src,
        version,
        libSrc,
        autoplay,
        crossOrigin,
        preload,
        poster,
        controlsList,
        autoPiP,
        disablePiP,
        disableRemotePlayback,
        mediaTitle,
        enableTextTracksByDefault,
        shouldRenderNativeTextTracks,
        isTextTrackVisible,
        currentTextTrack,
        __ref,
        onEvent,
        config,
        getAdapter,
        ref,
        getWebComponent,
        __mounted,
        $$scope,
        slots,
        vm_dash_binding
    ];
}
class Dash extends SvelteComponent {
    constructor(options) {
        super();
        init(this, options, instance, create_fragment, safe_not_equal, {
            class: 0,
            style: 1,
            src: 2,
            version: 3,
            libSrc: 4,
            config: 20,
            autoplay: 5,
            crossOrigin: 6,
            preload: 7,
            poster: 8,
            controlsList: 9,
            autoPiP: 10,
            disablePiP: 11,
            disableRemotePlayback: 12,
            mediaTitle: 13,
            enableTextTracksByDefault: 14,
            shouldRenderNativeTextTracks: 15,
            isTextTrackVisible: 16,
            currentTextTrack: 17,
            getAdapter: 21,
            ref: 22,
            getWebComponent: 23
        });
    }
    $on(type, callback) {
        return super.$on(type, callback);
    }
    $set($$props) {
        super.$set($$props);
    }
    /**  */
    get getAdapter() {
        return this.$$.ctx[21];
    }
    get ref() {
        return this.$$.ctx[22];
    }
    get getWebComponent() {
        return this.$$.ctx[23];
    }
}
export default Dash;
//# sourceMappingURL=Dash.js.map